import React, { Component } from 'react';
import connect from '@src/js/separate-logic/connect';
import GroupElementWrapperPresenter from './group-element-wrapper-presenter';
import '../slide.css';
import { RenderPostionType } from '@src/js/constant';
import ElementWrapper from '../element-wrapper';
import ScaleElementWrapper from '../scale-element-wrapper';
import {
    domIdOfCachedElement,
    elementHocType,
} from '@src/js/service/component-service/cached-element-dom-relation';

interface IGroupElementWrapperProps {
    // 父组件props
    fromScale: number;
    scale: number;
    component: any;
    getPageScale: () => number;
    elementRootId: string;
    onResize: () => void;
    onResizeStart: () => void;
    onResizeStop: () => void;
    onDrag: () => void;
    onDragStart: () => void;
    onDragStop: () => void;
    onRotate: () => void;
    onRotateStart: () => void;
    onRotateStop: () => void;
    handleMouseDown: () => void;
    handleMouseUp: () => void;
    relativeFlipH: number;
    relativeFlipV: number;
    relativeRotate: number;
    onElementUpdate: () => void;
    taskGroup: any;
    event: any;
    sync: any;
    region: string;

    setRef: (name: string, ref: any) => void;
}

export class GroupElementWrapper extends Component<IGroupElementWrapperProps> {
    public render() {
        const { fromScale, scale, getPageScale, component, elementRootId, onDrag, onDragStart,
            onDragStop, onResize, onResizeStart, onResizeStop, onRotate, onRotateStart, onRotateStop,
            handleMouseDown, handleMouseUp, relativeFlipH, relativeFlipV, relativeRotate, onElementUpdate,
            taskGroup, event, sync, setRef, region,
        } = this.props;

        if (fromScale === 1) {
            return (
                <ScaleElementWrapper
                    ref={ref => setRef('elementWrapperRef', ref)}
                    scale={scale}
                    getPageScale={getPageScale}
                    element={component}
                    fromScale={fromScale}
                    region={region}
                />
            );
        }

        return (
            <ElementWrapper
                ref={ref => setRef('elementWrapperRef', ref)}
                elementId={domIdOfCachedElement(elementHocType.ASYNC_HOC, component.key, null)}
                elementRootId={elementRootId}
                getPageScale={getPageScale}
                element={component}
                component={component}
                fromScale={fromScale}
                isGroupChildren={true}
                region={region}
                onResize={onResize}
                onResizeStart={onResizeStart}
                onResizeStop={onResizeStop}
                onDrag={onDrag}
                onDragStart={onDragStart}
                onDragStop={onDragStop}
                onRotate={onRotate}
                onRotateStart={onRotateStart}
                onRotateStop={onRotateStop}
                handleMouseDown={handleMouseDown}
                handleMouseUp={handleMouseUp}
                relativeRotate={relativeRotate}
                relativeFlipH={relativeFlipH}
                relativeFlipV={relativeFlipV}
                onElementUpdate={onElementUpdate}
                taskGroup={taskGroup}
                event={event}
                sync={sync}
                componentName={'ElementWrapper'}
            />
        );
    }
}

export default connect(
    GroupElementWrapperPresenter,
    null,
    GroupElementWrapper,
);
